import {
  DistrictListView,
  DistrictNewView,
  DistrictEditView,
} from '@/views/authenticated/districts';

export default [
  {
    path: '/districts',
    name: 'app_district_list',
    meta: { title: 'Districts', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: DistrictListView,
  },
  {
    path: '/districts/new',
    name: 'app_district_new',
    meta: { title: 'Add a District', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: DistrictNewView,
  },
  {
    path: '/districts/:district/edit',
    name: 'app_district_edit',
    meta: { title: 'Edit a District', redirectAuthenticatedUsers: false, requiresAdmin: true },
    component: DistrictEditView,
  },
];
